/**
 * Form Fuctionality
 *
 * @since   1.0.0
 * @package acs-calc
 */

(function($) {

	// factor vars
	var heat_load_factors = {
		season1 :  525 ,
		season2 :  495 ,
		season3 :  465 ,
		season4 :  405 ,
		season5 :  380 ,
		season6 :  330 ,
		season7 :  250 ,
		season8 :  220
	};
	var temp_factors = {
		temp78 :  0.68,
		temp79 :  0.77,
		temp80 :  0.85,
		temp81 :  0.93,
		temp82 :  1.00,
		temp83 :  1.07,
		temp84 :  1.15,
		temp85 :  1.23,
		temp86 :  1.31,
		temp87 :  1.40,
		temp88 :  1.48,
		temp89 :  1.56,
		temp90 :  1.65,
		temp100 :  3.00,
		temp104 :  3.50
	};
	var blanket_factors = {

	};

	// default vars
	var comparison_choice 		= 1;

	var location_label			= '';
	var location_choice			= '';

	var selected_season 		= 'season1';
	var selected_season_label	= '';
	var selected_temp 			= 'temp78';
	var selected_temp_label		= '78 Degrees';
	var selected_season_factor 	= heat_load_factors.season1;
	var selected_temp_factor 	= temp_factors.temp78;
	var surface_area			= 0;

	// Get Which Comparison Results to show
	$('#calc-btn-tab-links .calc-btn').on('click', function() {
		comparison_choice = $(this).data('selection');
	});

	// Get seasons based on selected location
	$(document).ready( function() {
		setArea( $('#acs-location-select').val() );
	});
	$('#acs-location-select').on( 'change', function(event) {
		setArea( $(this).val() );
	});

	/**
	 * Set the seasons available for the selected location
	 */
	setArea = function(areaSelected) {

		$.ajax({
			url: acsCalc.ajax_url,
			type: 'POST',
			data: {
				action 			: 'get_seasons',
				location_choice : areaSelected,
			},
			dataType: 'html',
			success: function(data) {

				$("#acs-season-select").html(data);

				// set the selected season variable
				selected_season = $('#acs-season-select > option').data('season');
				// set selected season label
				selected_season_label = $('#acs-season-select option:selected').val();
				// set the location label
				location_label = $('#acs-location-select option:selected').text();
				// set location choice
				location_choice = areaSelected;

			} //success
		});
	};

	/**
	 * Get form inputs and labels
	 * Surface area done in its own function getSurfaceArea()
	 */
	getFormInputs = function() {
		// Location input
		location_choice 		= $('#acs-location-select').val();
		location_label 			= $('#acs-location-select option:selected').text();

		// Season input
		selected_season 		= $('#acs-season-select').val();
		selected_season_label 	= $('#acs-season-select option:selected').text();

		// Temperature input
		selected_temp 			= $('#acs-temperature-select').val();
		selected_temp_label 	= $('#acs-temperature-select option:selected').text();

		// Solar blanket
		selected_blanket 		= $('#acs-solarblanket-select').val();
		selected_blanket_label 	= $('#acs-solarblanket-select option:selected').text();

	};

	/**
	 * Set the temp and season load factors based on input
	 */
	setLoadFactors = function() {
		// set factors
		selected_season_factor = heat_load_factors[selected_season];
		selected_temp_factor = temp_factors[selected_temp];
	};

	/**
	 * Set the temp and season load factors based on input
	 */
	getSurfaceArea = function() {
		// if there is a value in the Surface area input, use that
		// else use the lenght and width and calculate surface area
		if ( $.trim( $("#acs-surfacearea-input").val() ) ) {
			surface_area = $("#acs-surfacearea-input").val();
		} else {
			surface_area = $('#acs-width-input').val() * $('#acs-length-input').val();
		}
	};

	/**
	 * Function run on submit
	 * Takes in form values and sets heat and temp factors
	 */
	acs_calc_submit = function() {
		getFormInputs();
		getSurfaceArea();
		setLoadFactors();

		// JSON to send to getResults.php based on form selections

		// $.ajax({
		// 	url: acsCalc.acsCalcUrl + '/acs-calc/getResults.php',
		// 	type: 'POST',
		// 	data: json,
		// 	dataType: 'html',
		// 	success: function(data) {
		// 		$("#ac-calculator-container").addClass("showing-results");
		// 		$("#ac-calculator-results").html(data);
		// 	}
		// });

		$.ajax({
			url: acsCalc.ajax_url,
			type: 'POST',
			data: {
				location_label 		: location_label,
				comparison_choice 	: comparison_choice,
				location_choice 	: location_choice,
				season_choice 		: selected_season_label,
				surface_area 		: surface_area,
				water_temp 			: selected_temp,
				cover 				: selected_blanket,
				action 				: 'get_results',
				nonce 				: 'results_error',
			},
			dataType: 'html',
			success: function(data) {
				$("#ac-calculator-container").addClass("showing-results");
				$("#ac-calculator-results").html(data);
				$('html, body').animate({
                    scrollTop: $("#ac-calculator-results").offset().top -150
                }, 2000);
			}
		});

		return false; // prevent page from reloading
	};

	printTable = function() {
		var printr = window.open('','','width=500,height=500');
		printr.document.open("text/html");
		printr.document.write(document.getElementById('printArea').innerHTML);
		printr.document.close();
		printr.print();
	};

})(jQuery);